import { Button, Typography } from '@material-ui/core';
import styled from 'styled-components';

import NextStep from 'app/components/StyledStep/NextStep';
import PrevStep from 'app/components/StyledStep/PrevStep';

const LayoutForm = styled.form``;

const Content = styled.div<{ $usePadding?: boolean }>`
  display: flex;
  flex-flow: column;

  margin-top: ${({ $usePadding }) => ($usePadding ? '2.4rem' : 0)};

  > * {
    margin-bottom: 1.63rem;
  }

  .form-field__max-width {
    width: 80%;
    max-width: 18.75rem;
    margin-left: auto;
    margin-right: auto;
  }
`;

export const StyledButton = styled(Button)`
  padding: 1rem;
  margin: auto;

  border-radius: 0;
  box-shadow: none;

  font-weight: 300;
  font-size: 14px;
  line-height: 16px;
  text-transform: uppercase;
  letter-spacing: 0.015rem;
  color: ${({ theme: { shade } }) => shade['0']};

  :hover {
    box-shadow: none;
  }

  &.Mui-disabled {
    background-color: #9dc8f9;
    color: #ffffff;
    :hover {
      background-color: ${({
        theme: {
          palette: {
            primary: { main },
          },
        },
      }) => main};
    }
  }
`;

const Title = styled(Typography)``;

const Fade = styled.div`
  position: sticky;
  bottom: 0;

  display: flex;

  :last-child {
    margin-bottom: 0;
    padding-top: 1.25rem;
    padding-bottom: 2.7rem;
  }

  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 1)
  );
`;

export const StyledStep = {
  PrevStep,
  LayoutForm,
  Content,
  Title,
  NextStep,
  Fade,
};
